'use strict';

module.exports = require('../5/CheckObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./~/react-outside-click-handler/~/es-abstract/2019/RequireObjectCoercible.js
// module id = 1095
// module chunks = 0